"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MorningStar_meta_1 = require("../MorningStar.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', MorningStar_meta_1.MORNING_STAR_CATEGORY_KEY, MorningStar_meta_1.MORNING_STAR_COMPONENT_KEY, ['wrapper']);